import React from 'react';
import { useTheme } from 'styled-components';

export const GTResizerIcon = () => {
  const colors = useTheme().colors;
  return (
    <svg width="6" height="16" viewBox="0 0 6 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="3" cy="2" r="1.5" fill={colors.cflowerBlue} />
      <circle cx="3" cy="8" r="1.5" fill={colors.cflowerBlue} />
      <circle cx="3" cy="14" r="1.5" fill={colors.cflowerBlue} />
    </svg>
  );
};
